import { ReactNode } from 'react';
import { Thead, Tr, Th as CKTh, TableColumnHeaderProps } from '@chakra-ui/react';
import { Colors } from '@mercator-gcp/grout';
import SortableHeader from 'components/layout/Table/SortableHeader';
import { Z_INDEX_DICT } from 'utils/constants/zIndex';

const tableHeaderStyle = {
  fontWeight: '600',
  fontSize: '10px',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: 'brand.dark-green',
};

const stickyHeaderStyle = {
  '>tr>th': {
    position: 'sticky',
    top: '0',
    backgroundColor: Colors.White,
    zIndex: Z_INDEX_DICT.LEAD_TABLE_HEADER,
  },
};

const COLUMN_WIDTH = {
  COMPANY: '1fr',
  ACTIVE: '1fr',
  MENU: '1px', // Shrink to fit content
};

type ThProps = {
  colWidth?: string;
  children: ReactNode;
  sx?: TableColumnHeaderProps['sx'];
};

const Th = ({ colWidth = 'auto', sx = {}, children }: ThProps) => {
  return (
    <CKTh width={colWidth} sx={{ ...tableHeaderStyle, ...sx }}>
      {children}
    </CKTh>
  );
};

type TableHeaderProps = {
  sortKey?: 'name' | 'activeProjects';
  sortDirection?: 'asc' | 'desc';
  onSortColumn?: (column: 'name' | 'activeProjects') => void;
};

const TableHeader = ({ sortKey, sortDirection, onSortColumn }: TableHeaderProps) => {
  const isSortable = sortKey != null && sortDirection != null && onSortColumn != null;
  const isSorted = sortDirection === 'asc';

  return (
    <Thead sx={stickyHeaderStyle}>
      <Tr>
        <Th colWidth={COLUMN_WIDTH.COMPANY}>
          {isSortable ? (
            <SortableHeader
              headingKey="name"
              label="Company"
              currentHeading={sortKey}
              isSorted={isSorted}
              onClick={() => onSortColumn('name')}
            />
          ) : (
            'Company'
          )}
        </Th>
        <Th colWidth={COLUMN_WIDTH.ACTIVE}>
          {isSortable ? (
            <SortableHeader
              headingKey="activeProjects"
              label="active"
              currentHeading={sortKey}
              isSorted={isSorted}
              onClick={() => onSortColumn('activeProjects')}
            />
          ) : (
            'active'
          )}
        </Th>
        <Th colWidth={COLUMN_WIDTH.MENU}>{` `}</Th>
      </Tr>
    </Thead>
  );
};

export default TableHeader;
